<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>
<script>
import { postMessage } from "@/utils/postMessage.js";
export default {
  name: "app",
  data() {
    return {
    };
  },
  watch: {
    $route(val, oldVal) {
       let {
        origin,
        pathname
    } = location
      console.log ('route-val-all',origin + pathname + '#' + val.fullPath, val, oldVal)
      postMessage(val.fullPath, '*')
    }
  },
  methods: {
  },
};
</script>
<style lang="scss">
#app {
  background: #F9F9FB;
  height: 100%;
}
</style>
